import { Component, OnInit, Input, Renderer2, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { Store, select } from '@ngrx/store';

import * as fromBookmarkDataAccessLib from '@purplefront/bookmarks/data-access';
import { Langs } from '@purplefront/shared';
import * as fromSearchModalStore from '@purplefront/saved-search/data-access';
import * as fromRouterStore from '@purplefront/app-router/data-access';

@Component({
  selector: 'app-search-btn',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './search-btn.component.html',
  styleUrls: ['./search-btn.component.scss']
})
export class SearchButtonComponent implements OnInit, OnDestroy {
  @Input() type: string;
  @Input() savedSearch: fromBookmarkDataAccessLib.Bookmark;
  public searchString: string;
  public savedSearchId$: Observable<any>;
  public feedSlug: string;
  public search: string;
  public lang: Langs;

  private _isSearchModalOpen: boolean;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private _searchModalStore: Store<fromSearchModalStore.SearchModalState>,
    private _bookmarkStore: Store<fromBookmarkDataAccessLib.BookmarksState>,
    private _routerStore: Store<fromRouterStore.AppRouterState>,
    private _route: ActivatedRoute,
    private _router: Router,
    private _renderer: Renderer2
  ) {}

  ngOnInit() {
    this._routerStore
      .pipe(select(fromRouterStore.selectFeedSlug), takeUntil(this._ngUnsubscribe$))
      .subscribe((slug) => (this.feedSlug = slug));

    this._routerStore
      .pipe(select(fromRouterStore.selectContentLang), takeUntil(this._ngUnsubscribe$))
      .subscribe((lang) => (this.lang = lang));

    /**
     * Check if modal is open
     */

    this._searchModalStore
      .pipe(takeUntil(this._ngUnsubscribe$), select(fromSearchModalStore.isModalOpen))
      .subscribe((isOpen) => {
        this._isSearchModalOpen = isOpen;
      });

    /**
     * Select saved search id
     */

    this.savedSearchId$ = this._routerStore.pipe(select(fromRouterStore.selectSavedSearchId));
  }

  /**
   * Toggle search modal state (open / close)
   */

  toggleSearchModalState() {
    if (this._isSearchModalOpen) {
      this.closeModal();
    } else {
      this.openModal();
    }
  }

  /**
   * Open modal
   */

  openModal() {
    this._renderer.addClass(document.body, 'open');
    this._searchModalStore.dispatch(fromSearchModalStore.openSearchModal({ payload: { open: true } }));

    // TODO move to app-router
    if (this.savedSearch) {
      this._router.navigate(['./', 'select', 'feed', this.feedSlug, this.savedSearch.context['page'], this.lang], {
        relativeTo: this._route,
        queryParams: {
          search: this.savedSearch.filter,
          searchId: this.savedSearch.id
        }
      });
    }
  }

  /**
   * Close modal
   */

  closeModal() {
    this._renderer.removeClass(document.body, 'open');
    this._searchModalStore.dispatch(fromSearchModalStore.closeSearchModal({ payload: { open: false } }));
  }

  /**
   * Prevent memory leaks unsubscribe when destroy component
   */
  ngOnDestroy(): void {
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
  }
}
